import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { PATH_DASHBOARD } from "../../routes/paths";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  contacts: [],
};

export const createContact = createAsyncThunk(
  "createContact/contact",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("contacts", data);
      enqueueSnackbar("Contact is added successfully");
      navigate(PATH_DASHBOARD.contacts.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchContacts = createAsyncThunk(
  "fetchContacts/contact",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("contacts");

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateContact = createAsyncThunk(
  "updateContact/contact",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`contacts/${slug}`, data);

      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteContact = createAsyncThunk(
  "deleteContact/contact",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`contacts/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState,
  extraReducers: (builder) => {
    // TODO: create contact
    builder.addCase(createContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createContact.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch contact
    builder.addCase(fetchContacts.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchContacts.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.contacts = action.payload;
    });

    builder.addCase(fetchContacts.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update contact
    builder.addCase(updateContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateContact.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Contact is updated successfully");
      state.contacts.data = state.contacts.data.map((contact) =>
        contact.slug === action.payload.slug ? action.payload.data : contact
      );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete contact
    builder.addCase(deleteContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteContact.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contacts.data = state.contacts.data.filter(
        (contact) => contact.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Contact is deleted successfully");
    });

    builder.addCase(deleteContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default contactSlice.reducer;
